export default __webpack_public_path__ + "static/media/Ultimate.048f6e62.pdf";